import React from 'react';
import './style.scss';
import { T } from '../../../../constants';
import { useTranslation } from '../../../../hooks';

interface FreeSpinFooterProps {
  primaryText?: string;
  secondaryText?: string;
  primaryDisabled?: boolean;
  onPrimaryClick: () => void;
  onSecondaryClick: () => void;
}

const FreeSpinFooter: React.FC<FreeSpinFooterProps> = ({
  primaryText = T.PLAY_NOW,
  secondaryText = T.USE_LATER,
  primaryDisabled,
  onPrimaryClick,
  onSecondaryClick,
}) => {
  const translate = useTranslation();
  return (
    <div className="FreeSpinFooter">
      <button type="button" className="FreeSpinButton state-transparent large" onClick={onSecondaryClick}>
        <span className="FreeSpinButtonText">
          {translate(secondaryText)}
        </span>
      </button>
      <button
        type="button"
        className="FreeSpinButton state-yellow large"
        disabled={primaryDisabled}
        onClick={onPrimaryClick}
      >
        <span className="FreeSpinButtonText">
          {translate(primaryText)}
        </span>
      </button>
    </div>
  );
};

export default FreeSpinFooter;
